<template>
  <div class="dialogContent" @click="closeDialog">
    <el-dialog
      :title="dialogContent.title != '' ? dialogContent.title : '提示'"
      size="tiny"
      :visible="$store.state.Dialog.dialogName === dialogContent.dialogVisible" :top="top" :show-close="showClose" :close-on-click-modal="closeOnClickModal">
      <el-alert
        :title="dialogContent.content"
        type="warning"
        :closable="false"
        :show-icon = 'showIcon'>
      </el-alert>
      <span slot="footer" class="dialog-footer" v-show="dialogContent.btnShow == false? false: true">
        <el-button style="margin-right: 2px">取 消</el-button>
        <el-button type="primary" @click="submit" >{{dialogContent.confirm != '' ? dialogContent.confirm : '确认'}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import bus from '../../assets/js/bus'
  export default({
    props : ['dialogContent'],
    data(){
      return{
        dialogVisible:"",
        showClose:false,
        closeOnClickModal:true,
        top:"10%",
        showIcon:true
      }
    },
    mounted(){
      this.$nextTick(function(){
        var that = this;
      })
    },
    methods:{
      closeDialog(event){
        this.$store.commit('closeDialog',{
          className:event.target.className,
          innerText:event.target.innerText.replace(/\s+/g,""),
        })
      },
      submit(){
        var _this = this;
        _this.$emit("submit");
      },
    },
    watch:{
    }
  })
</script>

<style lang="scss">
  .dialogContent{
    .el-dialog{
      width: 400px;
    }
    .el-alert{
      padding-bottom: 0;
    }
    .el-alert__title{
      font-size: 14px;
    }
    .el-icon-warning{
      width: 18px;
      padding-left: 1px;
      color: #f7ba2a;
      font-size: 18px;
    }
  }

</style>



// WEBPACK FOOTER //
// dialogContent.vue?93b49ada